export * from 'vue-final-modal-real';

import { VueFinalModal as OriginalVFM } from 'vue-final-modal-real';
import { defineComponent, h } from 'vue';

export const VueFinalModal = defineComponent({
    name: 'VueFinalModal',
    inheritAttrs: false,
    props: {
        escToClose: {
            type: Boolean,
            default: true
        },
        focusTrap: {
            default: () => ({ allowOutsideClick: true })
        }
    },
    setup(props, { attrs, slots }) {
        return () => {
            const focusTrap = (props.focusTrap !== false && !props.escToClose)
                ? { allowOutsideClick: true, escapeDeactivates: false }
                : props.focusTrap;

            const originalOnBeforeClose = attrs.onBeforeClose;
            const onBeforeClose = () => {
                document.activeElement?.blur();
                if (typeof originalOnBeforeClose === 'function') originalOnBeforeClose();
            };

            return h(OriginalVFM, { ...attrs, escToClose: props.escToClose, focusTrap, onBeforeClose }, slots);
        };
    }
});
